import useModal from "../../../useModal";
import UseContext from "../../../../../hooks/useContext";
import Modalheader from "../../../components/header";
import React from "react";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";

const ConfirmSchedule = () => {
    const {toggle}=useModal()
    const {setData, data, handleNext, language} = UseContext()

    const handleSubmit = (e) => {
        e.preventDefault()
        data.isConfirmedSchedule = true
        handleNext()
        toggle()
    }

    return (
        <>
            <Modalheader
                hide={toggle}
                hideShow={true}
                closeLabel={language.getValue('missionCreation.modal.close', 'Fermer')}
                description="Les jours non remplis seront indiqués comme des journées aux horaires non renseignés pour l'intérimaire. Êtes-vous sûr de vouloir continuer ?"
            >
                Confirmer la sélection
            </Modalheader>
            {/*footer*/}
            <ModalFooter>
                <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
                    Annuler
                </Button>
                <Button size={'LG'} onClick={handleSubmit}>
                    Confirmer
                </Button>
            </ModalFooter>
        </>
    );
}

export default ConfirmSchedule;
